import axios from 'axios';

const prefix = a => 'Panel/LetterTemplate' + (a ? `/${a}` : '');

export default {
  index(params, config = {}) {
    const url = prefix();
    return params === true ? url : axios.get(url, {...config, params});
  },
  store(data = {}, config = {}) {
    const url = prefix();
    return data === true ? url : axios.post(url, data, config);
  },
  update(id, data = {}, config = {}) {
    const url = prefix(id);
    return id === true ? url : axios.put(url, data, config);
  },
  show(id, config = {}) {
    const url = prefix(id);
    return id === true ? url : axios.get(url, config);
  },
  destroy(id, config = {}) {
    const url = prefix(id);
    return id === true ? url : axios.delete(url, config);
  },
  // Bulk delete from the datatable selection.
  destroyMany(ids = [], config = {}) {
    return axios.post(prefix('destroyMany'), {ids}, config);
  },
  // Attach the Word file that IS the template. Multipart rather than the
  // base64 the images use: a letterhead .docx runs to megabytes.
  uploadDocx(id, file, config = {}) {
    const data = new FormData();
    data.append('file', file);
    return axios.post(prefix(`${id}/docx`), data, {
      ...config,
      headers: {...(config.headers || {}), 'Content-Type': 'multipart/form-data'}
    });
  },
  removeDocx(id, config = {}) {
    return axios.delete(prefix(`${id}/docx`), config);
  },
  // Duplicate a template (content + images) into a new, inactive one.
  replicate(id, config = {}) {
    return axios.post(prefix(`${id}/replicate`), {}, config);
  },
  // Claim fields that can be inserted into the template texts as {tokens}.
  tokens(config = {}) {
    return axios.get(prefix('tokens'), config);
  }
};
